import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-semi-bold" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddAndUpdateInclusionModal = _resolveComponent("AddAndUpdateInclusionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["ModalWithHeader"], {
      isOpen: $props.isOpen,
      maxWidth: true,
      onClose: $setup.closeModal
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, "Inclusion - " + _toDisplayString($setup.capitalizeFirstLetter($props.inclusion.type)), 1)
      ]),
      description: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.inclusion.inclusions, (inclusionItem, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "inclusion-container",
              key: index
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(inclusionItem.name), 1)
              ]),
              (inclusionItem.url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "inclusion-img",
                    src: inclusionItem.url
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inclusionItem.description, (desc, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(desc), 1))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    (_openBlock(), _createBlock(_component_AddAndUpdateInclusionModal, {
      isOpen: $setup.isEditModalOpen,
      inclusion: $setup.selectedInclusion,
      key: $setup.selectedInclusion ? $setup.selectedInclusion.name : 'new',
      mode: "update",
      onClose: _ctx.closeEditModal,
      onSubmit: _ctx.updateInclusion
    }, null, 8, ["isOpen", "inclusion", "onClose", "onSubmit"]))
  ], 64))
}